import { Link } from "react-router-dom";

const PaypalPaymentSuccess = () => {
  return (
    <div className="pt-5 pb-4">
      <div
        className="subscription-success-container"
        style={{ minHeight: "60vh", flexDirection: "column" }}
      >
        <div className="success-box">
          <h2 className="success-title">Payment Successful!</h2>
          <p className="success-message">
            Thank you for booking a nanny with us! Your reservation has been
            received, and we’re waiting for the nanny to accept the booking. If
            she’s unavailable, we’ll promptly arrange another suitable nanny for
            you. We appreciate your trust in our service!
          </p>

          <div className="success-actions">
            <Link to="/profile" className="btna btn-primarya">
              Go to Profile
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaypalPaymentSuccess;
